module.exports = __webpack_public_path__ + "img/mirage-g4-19.773aa7c8.png";